module.exports = __webpack_public_path__ + "static/media/style1-1.24e62784.gif";